import { restApi } from '../../api/restApiSlice';
import { CfFlowResponse } from './cloudflareFlowApi';

const cloudflareAccountConfirmationApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    confirmCfAccount: builder.mutation<CfFlowResponse, { domain: string }>({
      query: ({ domain }) => ({
        url: '/v3/cloudflare/account-confirmations',
        method: 'POST',
        params: { domain },
      }),
    }),
  }),
});

export { cloudflareAccountConfirmationApi };
export const { useConfirmCfAccountMutation } = cloudflareAccountConfirmationApi;
